// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'FAI',
    appLogoImage: require(`@src/assets/${process.env.REACT_APP_PATH_ASSETS_ORG}/images/logo/logo.svg`).default,
    appLogoImageMinified: require(`@src/assets/${process.env.REACT_APP_PATH_ASSETS_ORG}/images/logo/logoMinified.svg`).default
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: 'top-right' // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
